<template>
  <div class="loginwrap">
    <div class="userinfo">
      <div class="user">
        <img class="uimg" :src="userInfo.avatar_url" />
        <span class="username">{{ userInfo.nick_name }}</span>
        <span class="text">邀请你成为会员</span>
      </div>
    </div>

    <div class="content-text">
      <div class="name">想见AI，邀请你</div>
      <div class="title">体验AI智能作画，免费获取作画次数</div>
      <div class="know" @click="gotoAbout(10005)">了解Bit Hero</div>
    </div>

    <div class="form-box">
      <div class="form">
        <div>
          <input
            type="tel"
            maxlength="11"
            v-model="phone"
            placeholder="请输入手机号码"
          />
        </div>
        <div>
          <input
            type="tel"
            maxlength="6"
            v-model="code"
            placeholder="请输入手机验证码"
          />
          <span @click="getCode">{{ codeText }}</span>
        </div>
      </div>

      <div class="tips-x">
        <span
          class="check-btn"
          :class="{ active: ischeck }"
          @click="ischeck = !ischeck"
        ></span>
        <span>已阅读并同意</span>
        <span class="xieyi" @click="gotoAgreement(10002)"
          >《Bit Hero用户服务协议》</span
        >
      </div>

      <p class="button" :class="{ 'is-ok': get_login_type }" @click="login">
        同意协议并登录/注册
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data() {
    return {
      phone: '',
      code: '',
      input: '',
      codeNum: '获取验证码',
      codeText: '获取验证码',
      hasGet: false,
      time: null,
      agree_bol: false,
      recUserId: 0,
      userInfo: {
        avatar_url: 'https://qiniu.huashuyun.net/ai/home/logo.png',
        nick_name: 'Bit Hero',
      },
      ischeck: false,
    };
  },
  computed: {
    get_login_type() {
      // 判断是否可以点击登陆按钮
      if (/^[1][0-9]{10}$/.test(this.phone) && /^[0-9]{4}$/.test(this.code)) {
        return true;
      }
      return false;
    },
  },
  created() {
    localStorage.removeItem('ad_member_token');
    console.log(sessionStorage.getItem('recUserId'), '34324324');
    if (sessionStorage.getItem('recUserId') === null) {
      this.recUserId = 10001;
    } else {
      console.log('3333');
      this.recUserId = sessionStorage.getItem('recUserId');
    }
    this.getResUser();
  },
  methods: {
    // 根据用户id获取用户
    // 接口名：api/UserWallet/userInfoById?user_id=10002
    // 请求方式 get
    getResUser: async function () {
      console.log(this.recUserId, 'this.recUserId');
      let app = this;
      let res = await this.http.get(
        '/user/getUserInfoById',
        { user_id: this.recUserId },
        false
      );
      if (res.data.status === 200) {
        if (res.data.data.detail != null) {
          app.userInfo = res.data.data.detail;

          console.log(app.userInfo, 'app.userInfo');
          // app.userInfo.avatar_url = app.userInfo.avatar_url
          //   ? app.userInfo.avatar_url
          //   : 'https://qiniu.huashuyun.net/ai/home/logo.png';
          // app.userInfo.nick_name = app.userInfo.nick_name
          //   ? app.userInfo.nick_name
          //   : '想见AI';
        }

        console.log(app.userInfo, 'userinfo');
      }
    },
    agree() {
      // 同意协议
      this.agree_bol = !this.agree_bol;
    },
    VerifyCode: async function () {
      const res = await this.http.post(
        '/captcha/sendSmsCaptcha',
        {
          form: {
            mobile: this.phone,
          },
        },
        {
          no_need_token: true,
        }
      );
      if (res.data.status === 200) {
        this.$toast.success('发送成功');
      } else {
        this.codeText = '获取验证码';
        this.codeNum = '获取验证码';
        this.hasGet = false;
        clearInterval(this.time);
      }
    },
    getCode() {
      if (!/^[1][0-9]{10}$/.test(this.phone)) {
        this.$toast('请输入正确手机号码');
        return false;
      }
      if (this.hasGet) return false;
      let self = this;
      this.codeNum = 60;
      this.hasGet = true;
      this.time = setInterval(() => {
        self.codeNum--;
        self.codeText = self.codeNum + 's后重新获取';
        if (self.codeNum <= 0) {
          self.codeNum = '获取验证码';
          self.codeText = '获取验证码';
          self.hasGet = false;
          clearInterval(self.time);
        }
      }, 1000);
      this.VerifyCode();
    },
    LoginByH5: async function () {
      const res = await this.http.post(
        '/passport/login',
        {
          form: {
            smsCode: this.code,
            mobile: this.phone,
            isParty: false,
            rec_user_id: this.recUserId,
            isvip: 1,
            partyData: {},
          },
        },
        {
          no_need_token: true,
        }
      );
      if (res.data.status === 200) {
        // 将临时登陆凭证new_login_token设置再localStorage中
        sessionStorage.setItem('ad_member_token', res.data.data.token);
        this.$router.replace({
          path: '/Home?rec_user_id=' + this.recUserId,
        });
      }
    },
    gotoAgreement(id) {
      this.$router.replace({
        path: '/agreement?activeid=' + id + '&isback=1',
      });
    },
    gotoAbout(id) {
      this.$router.replace({
        path: '/about?activeid=' + id,
      });
    },
    login() {
      if (!this.ischeck) {
        this.$toast('请阅读并同意《乐高教育用户服务协议》！');
        return false;
      }
      this.LoginByH5();
    },
  },
};
</script>
<style lang="less" scoped>
.loginwrap {
  position: relative;
  box-sizing: border-box;
  background: url('https://qiniu.huayueshengwu.com/static/pic-dtbj.png')
    no-repeat;
  background-size: 100%;
  background-color: #272727;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;

  .userinfo {
    padding: 60px 0 0;
    margin-bottom: 28px;
    display: inline-block;
    flex-shrink: 0;

    .user {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 4px 17px;
      margin: auto;
      background: #ffffff;
      border-radius: 19px;
      box-shadow: 0px 4px 2px -2px rgba(89, 89, 89, 0.13);
      font-size: 14px;
      color: #262626;
      max-width: 250px;

      .uimg {
        width: 30px;
        height: 30px;
        margin-right: 6px;
        border-radius: 50%;
        flex-shrink: 0;
      }

      .username {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .text {
        flex-shrink: 0;
      }
    }
  }

  .content-text {
    text-align: center;
    color: #ffffff;
    flex-shrink: 0;
    margin-bottom: 25px;
    .name {
      font-size: 33px;
      line-height: 27px;
      margin-bottom: 10px;
      position: relative;
      z-index: 999;
      font-weight: bold;
    }
    .name::after {
      width: 230px;
      height: 7px;
      position: absolute;
      content: ' ';
      left: 5px;
      bottom: 0px;
      background: linear-gradient(90deg, #ff5400, #1dc98e);
      z-index: -1;
    }
    .title {
      font-size: 15px;
      line-height: 42px;
      margin-bottom: 30px;
    }

    .desc {
      font-size: 16px;
      line-height: 30px;
      margin-bottom: 30px;
    }
    .know {
      font-size: 14px;
      line-height: 20px;
      text-decoration: underline;
    }
  }

  .form-box {
    padding: 20px 32px;
    flex: 1;
    background: #272727;
    border-radius: 25px 25px 0px 0px;
    width: 100%;
    box-sizing: border-box;
  }

  .form {
    margin-top: 10px;

    > div {
      display: flex;
      justify-content: space-between;
      align-items: center;
      background: #272727;
      border-bottom: 1px solid #636363;
      height: 50px;

      input {
        width: 180px;
        height: 30px;
        font-size: 14px;
        color: #ffffff;
        background: #272727;
      }

      span {
        font-size: 14px;
        min-width: 50px;
        text-align: center;
        flex-shrink: 0;
        font-weight: bold;
        color: #f27105;
      }
    }
  }

  .button {
    width: 100%;
    font-size: 18px;
    color: #fff;
    height: 45px;
    line-height: 45px;
    text-align: center;
    opacity: 0.5;
    background: linear-gradient(90deg, #f27105, #1dc98e);
    border-radius: 25px;
    margin-top: 15px;
  }

  .is-ok {
    opacity: 1;
  }

  .tips {
    font-size: 13px;
    margin-top: 20px;
    line-height: 20px;
    color: #656565;

    a {
      color: #006837;
    }
  }

  .tips-x {
    margin-top: 20px;
    font-size: 13px;
    line-height: 19px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    span {
      display: block;
      color: #636363;
    }
    .check-btn {
      background: url('../assets/images/pubilc_unselect@2x.png') no-repeat;
      width: 17px;
      height: 17px;
      background-size: 100%;
      margin-right: 3px;
      opacity: 0.8;
    }
    .active {
      background: url('https://qiniu.huayueshengwu.com/static/choose%402x.png')
        no-repeat;
      width: 17px;
      height: 17px;
      background-size: 100%;
      margin-right: 3px;
      opacity: 0.8;
    }

    .xieyi {
      color: #f27105;
    }
  }
}
</style>
